import React, { Component } from 'react';

import appSettings from '../../config/settings';
import { reloadOnceOnChunkError } from '../../util/chunkLoadReload';
import { isBookingDetailsPath } from '../../util/sharetribeRateLimit';
import TooManyRequestsPage from '../../containers/TooManyRequestsPage/TooManyRequestsPage';

// Use ErrorBoyndary to catch ChunkLoadError
// https://reactjs.org/docs/error-boundaries.html
class LoadableComponentErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { error };
  }

  componentDidCatch(error) {
    reloadOnceOnChunkError(error);
    const path = typeof window !== 'undefined' ? window.location?.pathname : '';
    if (isBookingDetailsPath(path) && !this.recoverTimer) {
      this.recoverTimer = window.setTimeout(() => {
        this.recoverTimer = null;
        this.setState({ error: null, showRetry: false });
      }, 400);
    }
    // Sam 5:30 Oct 23: no bare "Retry now" flash; only offer it if recovery stalls.
    if (isBookingDetailsPath(path) && !this.retryTimer) {
      this.retryTimer = window.setTimeout(() => {
        this.retryTimer = null;
        if (this.state.error) this.setState({ showRetry: true });
      }, 4000);
    }
  }

  render() {
    if (this.state.error) {
      const path = typeof window !== 'undefined' ? window.location?.pathname : '';
      // Do not replace /order?edit=1 with the full busy page — that hid
      // the talker editor. Clear the error so TransactionPage remounts.
      if (isBookingDetailsPath(path)) {
        return (
          <div
            data-booking-details-recover="true"
            style={{ minHeight: '60vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 16, fontFamily: "'Source Sans 3', sans-serif", color: '#2b2b2b' }}
          >
            <p style={{ margin: 0, fontSize: 18 }}>Loading your booking…</p>
            {this.state.showRetry ? (
              <button
                type="button"
                onClick={() => this.setState({ error: null, showRetry: false })}
                style={{ background: '#e75b8f', color: '#fff', border: 0, borderRadius: 999, padding: '12px 24px', fontSize: 16, fontWeight: 700, fontFamily: 'inherit' }}
              >
                Try again
              </button>
            ) : null}
          </div>
        );
      }
      // Checkout is a separate webpack chunk. A Sharetribe 429, a render
      // throw after one, or a stale CheckoutPage chunk must never look
      // like Flex’s “app needs to be updated” 404.
      return <TooManyRequestsPage />;
    }

    return this.props.children;
  }
}

// LoadableComponentErrorBoundary helps in situations
// where production build changes in the server and
// long-living client app tries to fetch code chunks that don't exist anymore.
// Note: in development mode with Hot Module Reloading (HMR) in use, this causes error loops.
const UseLoadableErrorBoundaryOnlyInProdutionMode = props => {
  const { children } = props;
  return appSettings.dev ? (
    children
  ) : (
    <LoadableComponentErrorBoundary>{children}</LoadableComponentErrorBoundary>
  );
};
export { LoadableComponentErrorBoundary };
export default UseLoadableErrorBoundaryOnlyInProdutionMode;
